import { Component } from '@verndale/core';
import { getRandomColor } from '../helpers';

class FeaturedCaseStudy extends Component {
  constructor(el: HTMLElement) {
    super(el);

    this.generateRandomColor();
  }

  setupDefaults() {
    this.dom = {
      picture: this.el.querySelector<HTMLElement>('.picture')
    };
  }

  generateRandomColor() {
    const randomColor = getRandomColor('dark');

    (this.dom.picture as HTMLDivElement).classList.add(
      `picture--${randomColor.name}-glow`
    );
  }
}

export default FeaturedCaseStudy;
